import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCateringFormats } from '../../api/fetch-catering-formats';

export const fetchCateringFormatsThunk = createAsyncThunk(
    'fetchCateringFormats',
    async () => fetchCateringFormats(),
);
